import React from 'react';

const Modal = (props) => {
  const { setModalActive } = props;

  const stopModalPropagation = (e) => {
    e.stopPropagation();
  };

  return (

    <div className='modal-container' onClick={ () => setModalActive(false)}>
      <div
        className='modal'
        onClick={e => stopModalPropagation(e)}>

        <div className='modal-banner'>
          <a
            href='https://www.gov.uk/government/organisations/department-for-business-energy-and-industrial-strategy'
            target="_blank"
            rel="noreferrer">
            <img
              className='logo'
              src={process.env.PUBLIC_URL + '/images/DESNZ_invert.png'}
              alt='Department for Business Energy and Insdustrial Strategy'/>
          </a>
          <a
            href='https://www.barbour-abi.com'
            target="_blank"
            rel="noreferrer">
            <img
              className='logo'
              src={'https://barbourabi-production-platform-web-images.s3.eu-west-1.amazonaws.com/static/barbourabi-logo-new.svg'}
              alt='Barbour ABI'/>
          </a>
        </div>

        <h2 className='modal-header'>{props.projectType === 'heat_network' ? 'Heat Networks ' : 'Renewable Energy '}Planning Database</h2>
        <p className='modal-para'>{props.projectType === 'heat_network' ?
          'The Heat Networks Planning Database (HNPD) map tracks the progress of both district and communal heat networks through the planning system across the UK. It provides as accurate and comprehensive a snapshot as possible of projects. The information in this Heat Networks Planning Database is gathered from the separate planning authority databases throughout the UK.' :
          'The Renewable Energy Planning Database (REPD) map tracks the progress of renewable electricity over 150kW through the planning system across the UK. It provides as accurate and comprehensive a snapshot as possible of projects. The information in this Renewable Energy Planning Database is gathered from the separate planning authority databases throughout the UK.'}
        </p>
        <p className='modal-para'>Barbour ABI manages the data on behalf of DESNZ.</p>
        <button className='modal-button' onClick={() => setModalActive(false)}>Okay</button>
      </div>

    </div>
  )
}

export default Modal;
